import { render, staticRenderFns } from "./ProjectInfoAwsDocuments.vue?vue&type=template&id=7cbac44c&scoped=true"
import script from "./ProjectInfoAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoAwsDocuments.vue?vue&type=script&lang=ts"
import style0 from "./ProjectInfoAwsDocuments.vue?vue&type=style&index=0&id=7cbac44c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbac44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cbac44c')) {
      api.createRecord('7cbac44c', component.options)
    } else {
      api.reload('7cbac44c', component.options)
    }
    module.hot.accept("./ProjectInfoAwsDocuments.vue?vue&type=template&id=7cbac44c&scoped=true", function () {
      api.rerender('7cbac44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectInfoAwsDocuments.vue"
export default component.exports